// Normalizador central de RUT/RUC para comparación por clave natural (regla 10.7).
//
// Quita TODO lo que no sea dígito o K/k y uppercasea la K. Cubre los formatos heterogéneos
// que hay hoy en DB: con puntos, guión ASCII "-", guión Unicode "−" (U+2212), espacios, y
// RUT sin DV separado.
//   "76.811.980-5" / "76811980-5" / "76.811.980−5" / "768119805" → "768119805"
// Vacío / null / undefined → "".
//
// Uso: comparar normalizarRut(a) === normalizarRut(b) para detectar la MISMA entidad aunque
// los strings difieran en formato. NO se usa para display (para eso están los formatRut locales).
export const normalizarRut = (rut) => {
  if (!rut) return "";
  return String(rut)
    .replace(/[^\dKk]/g, "")
    .toUpperCase();
};
